import React from 'react'
import { Box, type SxProps, type Theme } from '@mui/material'

import type { GlyphPath, ProductGlyph } from 'constants/purchaseFlowRevamp/productGlyphs'

const pathKey = (path: GlyphPath) => (typeof path === 'string' ? path : path.d)

interface Props {
  glyph: ProductGlyph
  sx?: SxProps<Theme>
}

/** One product glyph as an inline SVG in `currentColor`, outlines and fills alike. */
export const ProductGlyphSvg: React.FC<Props> = ({ glyph, sx }) => (
  <Box component="svg" viewBox={glyph.viewBox} fill="none" aria-hidden sx={sx}>
    {glyph.paths.map((path) => (
      typeof path === 'string'
        ? <path key={path} d={path} fill="none" stroke="currentColor" strokeWidth={0.8} strokeMiterlimit={10} />
        : (
          <path
            key={pathKey(path)}
            d={path.d}
            fill="currentColor"
            fillRule={path.fillRule}
            clipRule={path.fillRule}
            stroke={path.stroke ? 'currentColor' : undefined}
            strokeWidth={path.stroke ? 0.8 : undefined}
            strokeMiterlimit={path.stroke ? 10 : undefined}
          />
        )
    ))}
  </Box>
)
